import { Box, Card, CardContent, Tab, Tabs, Typography } from '@mui/material';
import { IconComponent } from '@zippeditoolsjs/zippedi-icons';
import React, { useState } from 'react';
import AchievementAssignment from '../../../redux/containers/hall/AchievementAssignment';
import AchievementManagement from '../../../redux/containers/hall/AchievementManagement';

const HallOfHonorAdmin = ({ hall_honor_admin }) => {
    const [activeTab, setActiveTab] = useState(0);

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    // Don't render if user is not admin
    if (!hall_honor_admin) {
        return null;
    }

    return (
        <Card sx={{
            width: '100%',
            mt: 4,
            borderRadius: 2,
        }}>
            <CardContent sx={{ p: 0 }}>
                {/* Admin Header */}
                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    p: 3,
                    pb: 2,
                    // background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    background: 'linear-gradient(135deg, #1a242d 0%, #1a2c3c 100%)',
                    // background: '#1a242d',
                    color: '#fff',
                    borderTopLeftRadius: 8,
                    borderTopRightRadius: 8
                }}>
                    <IconComponent iconName="shield-check" style={{ fontSize: 20 }} />
                    <Typography variant="h6" sx={{ fontWeight: 600 }}>
                        Hall of Honor Admin
                    </Typography>
                </Box>

                {/* Tabs */}
                <Box sx={{ borderBottom: 1, borderColor: 'divider', px: 3 }}>
                    <Tabs
                        value={activeTab}
                        onChange={handleTabChange}
                        sx={{
                            '& .MuiTab-root': {
                                textTransform: 'none',
                                fontWeight: 500,
                                fontSize: '14px',
                            }
                        }}
                    >
                        <Tab
                            label={
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <IconComponent iconName="trophy" style={{ fontSize: 16 }} />
                                    Manage Achievements
                                </Box>
                            }
                        />
                        <Tab
                            label={
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <IconComponent iconName="user-plus" style={{ fontSize: 16 }} />
                                    Assign Achievements
                                </Box>
                            }
                        />
                    </Tabs>
                </Box>

                {/* Tab Content */}
                <Box sx={{ p: 3, pt: 2 }}>
                    {activeTab === 0 && <AchievementManagement />}
                    {activeTab === 1 && <AchievementAssignment />}
                </Box>
            </CardContent>
        </Card>
    );
};

export default HallOfHonorAdmin; 